{
  "friendsScreen": {
    "tabs": {
      "suggestions": "Sugerencias",
      "search": "Búsqueda",
      "requests": "Solicitudes"
    },
    "common": {
      "loading": "Cargando…"
    },
    "suggestions": {
      "sectionTitle": "Personas que quizás conozcas",
      "empty": "Sin sugerencias por ahora",
      "endOfList": "— Fin de las sugerencias —"
    },
    "search": {
      "placeholder": "Buscar por nombre o apellido…",
      "sectionTitle": "Resultados de la búsqueda",
      "noResults": "Sin resultados para «{{query}}»",
      "hint": "Encuentra nuevas personas"
    },
    "requests": {
      "receivedTab": "Recibidas ({{count}})",
      "sentTab": "Enviadas ({{count}})",
      "receivedSubtitle": "Quiere conectarse contigo",
      "sentSubtitle": "Enviaste una solicitud",
      "emptyReceived": "Sin solicitudes nuevas",
      "emptySent": "Sin solicitudes pendientes",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "cancel": "Cancelar"
    }
  },
  "messagesScreen": {
    "defaultUserName": "Yo",
    "loadingData": "Cargando datos",
    "you": "Tú:",
    "tabs": {
      "history": "Historial",
      "online": "En línea",
      "friends": "Amigos",
      "groups": "Grupos"
    },
    "search": {
      "placeholderHistory": "Buscar una conversación",
      "placeholderOnline": "Buscar un amigo en línea",
      "placeholderFriends": "Buscar un amigo",
      "placeholderGroups": "Buscar un grupo"
    },
    "status": {
      "online": "En línea",
      "offline": "Desconectado"
    },
    "preview": {
      "noMessage": "Sin mensajes",
      "photo": "📷 Foto",
      "video": "🎬 Video",
      "audio": "🎵 Audio",
      "file": "📁 Archivo"
    },
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "empty": {
      "noResultsTitle": "Sin resultados",
      "noConversationsFor": "Sin conversaciones para «{{query}}»",
      "noMessagesTitle": "No tienes mensajes",
      "noMessagesSubtitle": "Inicia una conversación con tus amigos",
      "noOnlineFriendsFor": "Sin amigos en línea para «{{query}}»",
      "noOnlineFriendsTitle": "Ningún amigo en línea",
      "noFriendsFor": "Sin amigos para «{{query}}»",
      "noFriendsTitle": "Sin amigos"
    },
    "sync": {
      "titleInProgress": "Sincronización en curso",
      "titleDone": "Datos actualizados",
      "titleError": "Sincronización fallida",
      "done": "Sincronización exitosa",
      "genericError": "Ocurrió un error.",
      "steps": {
        "checking": "Inicializando…",
        "refreshing": "Actualizando…",
        "syncing": "Sincronizando datos…",
        "syncingData": "Sincronización de datos"
      },
      "errors": {
        "pleaseReconnectData": "Vuelve a iniciar sesión para acceder a tus datos.",
        "pleaseReconnect": "Vuelve a iniciar sesión.",
        "cannotRefresh": "No se pudieron actualizar los datos. Vuelve a iniciar sesión.",
        "userNotFound": "No se encontró el identificador de usuario. Vuelve a iniciar sesión.",
        "syncFailed": "Ocurrió un error durante la sincronización. Verifica tu conexión e inténtalo de nuevo."
      }
    }
  },
  "profileScreen": {
    "loading": "Cargando...",
    "retry": "Reintentar",
    "memberSince": "Miembro desde {{date}}",
    "errors": {
      "cannotLoadProfile": "No se pudo cargar el perfil"
    },
    "roles": {
      "supreme": "⚡ Supreme",
      "adminPro": "👑 Admin PRO",
      "admin": "🛡 Administrador",
      "pro": "⭐ Usuario PRO"
    },
    "stats": {
      "cfa": "CFA",
      "trophies": "Trofeos"
    },
    "account": {
      "sectionLabel": "MI CUENTA",
      "topUp": {
        "title": "Recargar mi saldo",
        "sub": "Rápido · Seguro · Mobile Money"
      },
      "settings": {
        "title": "Configuración",
        "sub": "Nombre, apellido, fecha de nacimiento"
      },
      "privacy": {
        "title": "Privacidad",
        "sub": "Privacidad, datos y seguridad"
      },
      "guide": {
        "title": "Guía de uso",
        "sub": "Todo sobre Harmonia"
      }
    },
    "info": {
      "sectionLabel": "INFORMACIÓN",
      "lastName": "Apellido",
      "firstName": "Nombre",
      "birthDate": "Fecha de nacimiento"
    },
    "posts": {
      "title": "Publicaciones ({{count}})",
      "publishButton": "Publicar",
      "emptyTitle": "Sin publicaciones",
      "emptySub": "¡Comparte tu primera publicación!"
    },
    "post": {
      "tapToPlay": "Toca para reproducir",
      "commentsCount_one": "{{count}} comentario",
      "commentsCount_other": "{{count}} comentarios",
      "sharesCount_one": "{{count}} compartido",
      "sharesCount_other": "{{count}} compartidos"
    },
    "postDetails": {
      "title": "📊 Detalles",
      "author": "Autor:",
      "published": "Publicado:",
      "reactions": "Reacciones:",
      "close": "Cerrar"
    },
    "avatar": {
      "updated": "¡Foto de perfil actualizada!",
      "errors": {
        "accessRequired": "Se requiere acceso a las fotos.",
        "cannotUpdate": "No se pudo actualizar la foto"
      }
    },
    "createPost": {
      "title": "Nueva publicación",
      "placeholder": "¿Qué hay de nuevo?",
      "photo": "Foto",
      "video": "Video",
      "videoReady": "Video listo",
      "publish": "Publicar",
      "published": "¡Publicación publicada!",
      "imageAdded": "¡Imagen añadida!",
      "videoAdded": "¡Video añadido!",
      "visibility": {
        "public": "Público",
        "friends": "Amigos",
        "pro": "PRO",
        "private": "Privado"
      },
      "errors": {
        "contentRequired": "El contenido es obligatorio",
        "limitReached": "Límite de publicaciones alcanzado.",
        "cannotPublish": "No se pudo publicar",
        "mediaAccessRequired": "Se requiere acceso a los medios.",
        "cannotAddMedia": "No se pudo añadir el contenido multimedia"
      }
    },
    "settings": {
      "header": {
        "title": "Configuración",
        "subtitle": "Modifica tu información personal"
      },
      "updated": "¡Perfil actualizado!",
      "fields": {
        "lastName": "Apellido",
        "lastNamePlaceholder": "Tu apellido",
        "firstName": "Nombre",
        "firstNamePlaceholder": "Tu nombre",
        "birthDate": "Fecha de nacimiento"
      },
      "language": {
        "label": "Idioma",
        "intro": "Elige el idioma en el que deseas usar Harmonia. El cambio se aplica de inmediato a toda la aplicación.",
        "options": {
          "fr": { "name": "Francés", "native": "Français" },
          "en": { "name": "Inglés", "native": "English" },
          "es": { "name": "Español", "native": "Español" },
          "pt": { "name": "Portugués", "native": "Português" }
        }
      },
      "actions": {
        "cancel": "Cancelar",
        "save": "Guardar"
      },
      "errors": {
        "nameRequired": "Nombre y apellido obligatorios",
        "cannotSave": "No se pudo guardar",
        "cannotChangeLanguage": "No se pudo cambiar el idioma"
      }
    }
  },
  "vueProfilModal": {
    "loading": "Cargando...",
    "memberSince": "Miembro desde {{date}}",
    "premiumBadge": "Premium",
    "actions": {
      "sendInvite": "Enviar invitación",
      "cancelRequest": "Cancelar solicitud",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "removeFriend": "Quitar amigo"
    },
    "errors": {
      "cannotLoadProfile": "No se pudo cargar el perfil"
    }
  },
  "chatBox": {
    "retry": "Reintentar",
    "loadingData": "Cargando datos",
    "loadingEllipsis": "Cargando…",
    "loadPreviousMessages": "Ver mensajes anteriores",
    "messageDeleted": "Mensaje eliminado",
    "privateReply": "Respuesta privada",
    "edited": "editado",
    "offlineBanner": "Sin conexión — los mensajes se reenviarán automáticamente",
    "status": {
      "typing": "Escribiendo...",
      "typingEllipsis": "Escribiendo…",
      "online": "En línea",
      "offline": "Desconectado",
      "someoneTyping": "Alguien está escribiendo...",
      "someoneTypingEllipsis": "Alguien está escribiendo…",
      "memberCount_one": "{{count}} miembro",
      "memberCount_other": "{{count}} miembros"
    },
    "empty": {
      "title": "Sin mensajes",
      "subtitle": "¡Inicia la conversación!"
    },
    "replyBar": {
      "publicPrefix": "Respuesta pública a ",
      "privatePrefix": "Respuesta privada a "
    },
    "editBar": {
      "label": "Editar mensaje"
    },
    "input": {
      "placeholder": "Mensaje...",
      "editPlaceholder": "Editar mensaje..."
    },
    "media": {
      "document": "Documento",
      "file": "Archivo",
      "voiceNote": "Nota de voz"
    },
    "recording": {
      "inProgress": "En curso...",
      "inProgressEllipsis": "Grabando…"
    },
    "actions": {
      "replyPublicly": "Responder en público",
      "replyPubliclySub": "Todo el grupo ve la respuesta",
      "replyPrivately": "Responder en privado",
      "replyPrivatelySub": "Visible solo para ti y el destinatario",
      "makePrivate": "Hacer privado",
      "makeVisible": "Hacer visible",
      "edit": "Editar",
      "editSub": "Posible mientras no se haya leído",
      "delete": "Eliminar",
      "cancel": "Cancelar"
    },
    "errors": {
      "uploadUrlGeneration": "Error al generar la URL",
      "uploadFailed": "Error durante la subida",
      "uploadFailedHttp": "Error al enviar (HTTP {{status}})",
      "uploadConfirmation": "Error de confirmación",
      "transferFailed": "Error durante la transferencia del archivo.",
      "microphonePermission": "Se requiere permiso de micrófono. Verifica los permisos del navegador.",
      "permissionRequired": "Permiso requerido.",
      "cannotStartRecording": "No se pudo iniciar la grabación.",
      "audioFileCreation": "Error al crear el archivo de audio."
    }
  },
  "audioFeedModal": {
    "runNumber": "Run #{{number}}",
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "tikTokVideoModal": {
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "commentLikersModal": {
    "loading": "Cargando…",
    "likesCount_one": "me gusta",
    "likesCount_other": "me gusta",
    "likedThisComment": "Le gustó este comentario",
    "likePill": "Me gusta",
    "empty": {
      "title": "Sin me gusta por ahora",
      "subtitle": "¡Sé el primero en reaccionar!"
    }
  },
  "limitNotification": {
    "titlePro": "Límite PRO alcanzado",
    "titleDaily": "Límite diario",
    "upgradeButton": "Pasar a PRO"
  },
  "legalDocumentScreen": {
    "defaultBadgeText": "Documento legal oficial",
    "lastUpdated": "Última actualización: {{date}}",
    "sectionsLabel": "SECCIONES",
    "copyright": "© {{year}} Harmonia · Todos los derechos reservados",
    "intro": {
      "title": "Tu privacidad, nuestra prioridad",
      "text": "Harmonia se compromete a proteger tus datos con el máximo rigor. Ningún dato se vende ni se transmite a terceros comerciales."
    },
    "pills": {
      "zeroTracking": "Cero rastreo",
      "encrypted": "Cifrado",
      "gdpr": "RGPD",
      "internalAdsOnly": "Solo publicidad interna"
    },
    "contact": {
      "title": "¿Alguna pregunta sobre tus datos?"
    },
    "footer": {
      "privacy": "Privacidad",
      "cookies": "Cookies",
      "terms": "Términos",
      "rules": "Normas"
    }
  },
  "shareButton": {
    "title": "Compartir",
    "sharedOnHarmonia": "Compartido en Harmonia ✓",
    "shareWithFriends": "Compartir con mis amigos",
    "visibleInFriendsFeed": "Visible en el feed de tus amigos",
    "socialNetworks": "Redes sociales",
    "more": "Más",
    "cancel": "Cancelar"
  },
  "submissionCard": {
    "runLabel": "Run #{{number}} — {{title}}",
    "vote": "Votar",
    "voted": "Votado 💪",
    "badges": {
      "arts": "🎨 Artes",
      "artisanat": "🪡 Artesanía"
    },
    "mediaBadges": {
      "audio": "Audio",
      "video": "Video",
      "artisanat": "Artesanía"
    }
  },
  "publicShopScreen": {
    "loadingShop": "Cargando la tienda…",
    "newBadge": "Nuevo",
    "products": "Productos",
    "noProducts": "Aún no hay productos publicados.",
    "subscribe": "Suscribirse",
    "retry": "Reintentar",
    "whatsappMessage": "Hola, estoy descubriendo tu tienda \"{{name}}\" en Harmonia Market.",
    "errors": {
      "shopNotFound": "Esta tienda no existe o ya no está disponible.",
      "cannotLoadShop": "No se pudo cargar esta tienda.",
      "cannotReachServer": "No se pudo contactar al servidor."
    }
  },
  "publicProductScreen": {
    "loadingProduct": "Cargando el producto…",
    "newBadge": "Nuevo",
    "back": "Volver",
    "retry": "Reintentar",
    "defaultMetaTitle": "Producto",
    "descriptionTitle": "Descripción",
    "inStock_one": "En stock ({{count}})",
    "inStock_other": "En stock ({{count}})",
    "outOfStock": "Sin stock",
    "contactViaWhatsApp": "Contactar por WhatsApp",
    "buy": "Comprar",
    "learnMore": "Saber más",
    "call": "Llamar",
    "goToShop": "Ir a la tienda",
    "whatsappMessage": "Hola, estoy interesado(a) en \"{{name}}\" en Harmonia Market.",
    "condition": {
      "new": "Nuevo",
      "used": "Usado",
      "refurbished": "Reacondicionado"
    },
    "errors": {
      "productNotFound": "Este producto no existe o ya no está disponible.",
      "cannotLoadProduct": "No se pudo cargar este producto.",
      "cannotReachServer": "No se pudo contactar al servidor."
    }
  },
  "commentCaMarcheScreen": {
    "cta": "Crear mi cuenta gratis",
    "seo": {
      "title": "¿Cómo funciona? Guía completa de Harmonia World",
      "description": "Descubre cómo funciona Harmonia World: crea tu cuenta, participa en concursos de talento en 6 disciplinas, únete a una comunidad creativa o crea tu tienda en línea con tu propio sitio web profesional. Guía completa paso a paso.",
      "ogDescription": "Concursos de talento, comunidad creativa, tiendas en línea: la guía completa del funcionamiento de Harmonia World."
    },
    "hero": {
      "titleLine1": "¿Cómo funciona",
      "titleLine2": "Harmonia World?",
      "sub": "Harmonia World es una plataforma social que reúne tres universos en un solo lugar: concursos de talento abiertos a todos, una comunidad creativa internacional y un marketplace que permite a cualquiera crear su propia tienda en línea con un sitio web profesional. Esta guía explica en detalle cada función, paso a paso."
    },
    "presentation": {
      "chip": "PRESENTACIÓN",
      "title": "Una plataforma, tres universos",
      "p1": "Harmonia World está disponible en la web y en móvil. Permite a cada miembro crear un perfil, publicar contenido, interactuar mediante la mensajería y los grupos, participar en concursos de talento en seis disciplinas, jugar juegos de cultura general y estrategia, y — para comerciantes, artesanos y emprendedores — crear una tienda en línea acompañada de un verdadero sitio web personalizable.",
      "p2": "La plataforma se basa en una convicción simple: el talento no tiene fronteras. Cada disciplina abre la puerta a concursos regulares, donde los miembros compiten con amabilidad, son apoyados por el voto de la comunidad y pueden ver su talento recompensado con trofeos entregados públicamente."
    },
    "gettingStarted": {
      "chip": "COMENZAR",
      "title": "Crear tu cuenta e iniciar sesión",
      "step1": {
        "title": "Registro",
        "desc": "Crea tu cuenta con tu apellido, nombre, dirección de correo y una fecha de nacimiento, o regístrate directamente con Google en un clic. El registro está abierto a cualquier persona, en cualquier parte del mundo, sin restricción de edad."
      },
      "step2": {
        "title": "Verificación del correo",
        "desc": "Se envía automáticamente un correo de confirmación. Basta con hacer clic en el enlace recibido y volver a la aplicación para activar definitivamente la cuenta."
      },
      "step3": {
        "title": "Inicio de sesión",
        "desc": "Una vez activada la cuenta, el inicio de sesión se realiza con el correo y la contraseña elegidos. Es posible permanecer conectado para evitar volver a ingresar tus credenciales cada vez."
      },
      "step4": {
        "title": "Contraseña olvidada",
        "desc": "En caso de olvido, se envía un enlace de restablecimiento por correo para elegir una nueva contraseña de forma segura."
      }
    },
    "talentHub": {
      "chip": "CENTRO DE TALENTOS",
      "title": "Seis disciplinas, concursos cada semana",
      "p1": "El Centro de Talentos ofrece concursos activos repartidos en seis grandes disciplinas. Cada semana se abren nuevos desafíos para todos los miembros. Los participantes envían sus creaciones o compiten directamente, y luego la comunidad vota para elegir a los mejores talentos. Los concursos que llevan a una etapa final presencial se realizan en un país elegido aleatoriamente por Harmonia, con un jurado experto seleccionado para garantizar la equidad.",
      "p2": "Harmonia World no ofrece ningún juego de azar. El objetivo exclusivo de los concursos es revelar y recompensar talentos reales, evaluados por el voto de la comunidad y, para las finales, por jurados expertos."
    },
    "disciplines": {
      "strategie": {
        "label": "Juegos de Estrategia",
        "tagline": "Pura reflexión y táctica",
        "desc": "Awalé y Damas: enfréntate a tus rivales en intensos duelos de estrategia."
      },
      "connaissance": {
        "label": "Conocimientos",
        "tagline": "Pon a prueba tu saber",
        "desc": "Verdadero o Falso: duelos intelectuales tan emocionantes como impredecibles."
      },
      "arts": {
        "label": "Artes",
        "tagline": "Creatividad y expresión",
        "desc": "Fotografía, Dibujo, Diseño: muestra tus creaciones y recibe el reconocimiento que merecen."
      },
      "performance": {
        "label": "Performance",
        "tagline": "Sube al escenario",
        "desc": "Comedia, Danza, Teatro: encarna, cautiva, trasciende."
      },
      "musique": {
        "label": "Música",
        "tagline": "Haz vibrar el escenario",
        "desc": "Canto, Piano, Guitarra: tu voz, tus instrumentos, tu huella en el mundo."
      },
      "artisanat": {
        "label": "Artesanía",
        "tagline": "Excelencia en el oficio",
        "desc": "Costura, Carpintería, Peluquería, Soldadura, Mecánica: oficios nobles, maestría poco común."
      }
    },
    "community": {
      "chip": "COMUNIDAD",
      "title": "Publicar, conversar, hacer amigos",
      "p1": "El feed de noticias permite a cada miembro publicar contenido (texto, y para los miembros PRO, fotos y videos) con un nivel de visibilidad elegido: público, visible solo para amigos, para amigos de amigos, o estrictamente privado. Las publicaciones se pueden marcar con me gusta, comentar, compartir y guardar.",
      "p2": "Harmonia también ofrece mensajería privada y grupos de discusión, así como un sistema de amigos con sugerencias, búsqueda de usuarios y gestión de solicitudes enviadas o recibidas."
    },
    "proSolution": {
      "chip": "SOLUCIÓN PRO",
      "title": "Tu tienda, tu sitio web, tu mundo",
      "p1": "Los miembros PRO pueden crear una tienda directamente desde Harmonia. Cada tienda se convierte en un verdadero sitio web, personalizable en su diseño, presentación e identidad visual, accesible tanto desde la aplicación como mediante un enlace público funcional en la web — sin que los visitantes necesiten una cuenta para consultar la tienda o sus productos.",
      "step1": {
        "title": "Crear tu tienda",
        "desc": "Desde el Market, los miembros PRO acceden a la configuración de su tienda y la publican en pocos pasos."
      },
      "step2": {
        "title": "Personalizar tu sitio web",
        "desc": "El diseño y muchos parámetros del sitio web asociado a la tienda se pueden ajustar para que refleje la identidad del comerciante, artesano o emprendedor."
      },
      "step3": {
        "title": "Publicar productos",
        "desc": "Cada producto añadido dispone automáticamente de su propia página y su propio enlace web, consultable y compartible de forma independiente de la tienda."
      },
      "step4": {
        "title": "Ser visible en todas partes",
        "desc": "El enlace de la tienda y el de cada producto se pueden compartir en cualquier plataforma, permitiendo vender e intercambiar con clientes de todo el mundo."
      }
    },
    "proStatus": {
      "chip": "ESTATUS PRO",
      "title": "Lo que desbloquea el estatus PRO",
      "p1": "El estatus PRO permite publicar con más frecuencia (3 publicaciones por día frente a 1 para los miembros estándar), añadir fotos y videos a las publicaciones, enviar medios y notas de voz en los mensajes, y sobre todo crear una tienda en línea con su propio sitio web público. Una insignia distintiva hace visible el estatus en el perfil."
    },
    "faq": {
      "chip": "PREGUNTAS FRECUENTES",
      "title": "Preguntas frecuentes",
      "q1": {
        "question": "¿Es Harmonia World accesible en todo el mundo?",
        "answer": "Sí. El registro está abierto a cualquier persona en el mundo, sin restricción de edad, y la plataforma está disponible en la web y en móvil."
      },
      "q2": {
        "question": "¿Los concursos son juegos de azar?",
        "answer": "No. Harmonia World no ofrece ningún juego de azar. El objetivo exclusivo de los concursos es revelar y recompensar talentos reales gracias al voto de la comunidad y, para las finales, a jurados expertos."
      },
      "q3": {
        "question": "¿Se necesita una cuenta de Harmonia para consultar una tienda?",
        "answer": "No. Cada tienda publicada dispone de un enlace público funcional, consultable por cualquier visitante sin crear una cuenta."
      },
      "q4": {
        "question": "¿Cuál es la diferencia entre una cuenta estándar y una cuenta PRO?",
        "answer": "La cuenta PRO permite publicar más, añadir medios enriquecidos a las publicaciones y mensajes, y sobre todo crear una tienda en línea con su propio sitio web público."
      }
    }
  }
}
